import React, { Component } from "react";
import styles from "./Analytics.scss";
import read from "../../auth/authUser";
import {
	getVisitorsData,
	getJobData
} from "../../../actions/Analytics/analytics";
import { withRouter, Redirect } from "react-router-dom";
import classnames from "classnames";
import DoughnutTemplate from "./DoughnutTemplate";
import WordCloudTemplate from "./WordCloudTemplate";
import Loader from "../../Loader/Loader";
import { isMobile } from "react-device-detect";
import MapLocation from "./MapLocation";
import LocationStats from "./LocationStats";
import SurveyResults from "./SurveyResults";
import auth from "../../auth/authHelper";

class Analytics extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: undefined,
			docs: [],
			total_visitors: 0,
			todays_visitors: 0,
			most_searched_job_term: "",
			location_details: null,
			most_visits: "",
			most_visits_percentage: 0,
			searched_keywords: {},
			sector_interest_details: {},
			job_interest_sector: [],
			sector_opening_details: {},
			job_opening_sector: [],
			job_sector: "interest",
			transit_choices: null,
			amenities_choices: null,
			services_choices: null,
			home_choices: null,
			backyard_choices: null,
			homeownership_choices: null,
			salary_details: null,
			redirectToSignin: false,
		};
	}

	componentDidMount = () => {
		var id = auth.isAuthenticated().user._id;
		this.init(id);
	}

	init = (userId) => {
		const jwt = auth.isAuthenticated();
		getVisitorsData()
		read(
      {
        userId: userId
      },
      { t: jwt.token }
    ).then(data => {
      if (data.error) {
        this.setState({ redirectToSignin: true });
      } else {
				this.setState({
					user: data
				});
      }
    }).catch(err => console.log(err))
		getVisitorsData().then(res => {
			let results = res.data.results;
			this.jobSearchKeyword(results.searched_keywords);
			this.getLocationData(results.location_details);
			this.setSectorInterest(results.sector_interest_details);

			this.setState({
				total_visitors: results.total_visitors,
				todays_visitors: results.todays_visitors,
				searched_keywords: results.searched_keywords,
				location_details: results.location_details,
				sector_interest_details: results.sector_interest_details,
				transit_choices: results.transit_choices,
				amenities_choices: results.amenities_choices,
				services_choices: results.services_choices,
				home_choices: results.home_choices,
				backyard_choices: results.backyard_choices,
				homeownership_choices: results.homeownership_choices,
				salary_details: results.salary_details
				});
			})
			.catch(err => {
				console.log(err);
			});

		getJobData().then(res => {
			let results = res.data.results;

			this.setSectorOpening(results.sector_opening_details);

			this.setState({
				sector_opening_details: results.sector_opening_details
			});
		});
	};

	getLocationData = docs => {
		let location_details = docs.details;
		let max = 0;
		let percentage = 0;
		let most_visits = "";

		for (var key in location_details) {
			if (location_details[key] > max) {
				max = location_details[key];
				most_visits = key;
			}
		}
		percentage = Math.round((max / docs.total) * 100);

		this.setState({
			most_visits,
			most_visits_percentage: percentage
		});
	};

	jobSearchKeyword = docs => {
		let max = 0;
		let most_searched = "";

		for (var key in docs) {
			if (docs[key] > max) {
				max = docs[key];
				most_searched = key;
			}
		}

		this.setState({
			most_searched_job_term: most_searched
		});
	};

	setSectorInterest = docs => {
		let data = [];

		for (var key in docs.details) {
			data.push({ label: key, value: docs.details[key] });
		}
		this.setState({
			job_interest_sector: data
		});
	};

	setSectorOpening = docs => {
		let data = [];

		for (var key in docs.details) {
			data.push({ label: key, value: docs.details[key] });
		}
		this.setState({
			job_opening_sector: data
		});
	};

	setJobInterest = type => {
		this.setState({
			job_sector: type
		});
	};

	render() {
		const {
			total_visitors,
			todays_visitors,
			most_searched_job_term,
			most_visits,
			most_visits_percentage,
			job_interest_sector,
			job_opening_sector,
			job_sector,
			searched_keywords,
			location_details,
			transit_choices,
			amenities_choices,
			services_choices,
			home_choices,
			backyard_choices,
			homeownership_choices,
			salary_details
		} = this.state;

		if (!this.state.user) {
			return <Loader />;
		}
		if (this.state.redirectToSignin) {
			return <Redirect to="/signin" />;
		}
		return (
			<div className={styles.analytics}>
				{/* <div className={styles.sidenav} /> */}
				<div className={styles.wrapper}>
					<div className={styles.cards}>
						<div
							className={classnames(
								"card text-white mb-3",
								styles.card
							)}
							style={{
								maxWidth: "18rem",
								backgroundColor: "#18BACB"
							}}
						>
							<div className="card-body">
								<h5 className="card-title">{total_visitors}</h5>
								<p className="card-text">total visitors</p>
							</div>
						</div>
						<div
							className={classnames(
								"card text-white mb-3",
								styles.card
							)}
							style={{
								maxWidth: "18rem",
								backgroundColor: "#6184A7"
							}}
						>
							<div className="card-body">
								<h5 className="card-title">
									{todays_visitors}
								</h5>
								<p className="card-text">
									unique visitors today
								</p>
							</div>
						</div>
						<div
							className={classnames(
								"card text-white mb-3",
								styles.card
							)}
							style={{
								maxWidth: "18rem",
								backgroundColor: "#3B5A87"
							}}
						>
							<div className="card-body">
								<h5 className="card-title">
									<em>"{most_searched_job_term}"</em>
								</h5>
								<p className="card-text">
									is the most searched for job
								</p>
							</div>
						</div>
						<div
							className={classnames(
								"card text-white mb-3",
								styles.card
							)}
							style={{
								maxWidth: "18rem",
								backgroundColor: "#592C2D"
							}}
						>
							<div className="card-body">
								<h5 className="card-title">{most_visits}</h5>
								<p className="card-text">
									leads the origin of most of our visitors
									with <span>{most_visits_percentage}%</span>
								</p>
							</div>
						</div>
					</div>
					{total_visitors && (
						<div className={styles.mapwrapper}>
							<MapLocation
								location_details={location_details.latlng_arr}
							/>
						</div>
					)}
					{location_details && (
						<div className={styles.sectionwrapper}>
							<LocationStats data={location_details} />
						</div>
					)}
					{!isMobile && (
						<div className={styles.secondsection}>
							<div
								className={classnames(
									"center",
									styles.sswrapper
								)}
							>
								<div className="col text-center">
									<button
										className={classnames(
											"btn btn-outline-secondary btn-sm",
											job_sector === "interest"
												? "active"
												: ""
										)}
										onClick={() =>
											this.setJobInterest("interest")
										}
									>
										job interest
									</button>
									<button
										className={classnames(
											"btn btn-outline-secondary btn-sm",
											job_sector === "opening"
												? "active"
												: ""
										)}
										onClick={() =>
											this.setJobInterest("opening")
										}
									>
										job opening
									</button>
								</div>
								{job_interest_sector && (
									<DoughnutTemplate
										data={
											job_sector === "interest"
												? job_interest_sector
												: job_opening_sector
										}
									/>
								)}
							</div>
							{searched_keywords && (
								<div className={styles.wcwrapper}>
									Job Search Word Cloud
									<WordCloudTemplate
										data={searched_keywords}
									/>
								</div>
							)}
						</div>
					)}

					{total_visitors && (
						<div className={styles.sectionwrapper}>
							<SurveyResults
								Transit={transit_choices}
								Amenities={amenities_choices}
								Services={services_choices}
								Home={home_choices}
								HomeOwnership={homeownership_choices}
								Backyard={backyard_choices}
								SalaryDetails={salary_details}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default withRouter(Analytics);



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/Analytics.js